/* PreNumbers Financial Builder — Cost Allocations (reskinned).
   REPLACES: src/components/FinancialBuilder/Misc/CostAllocations.jsx
   Rendered inside the Fine-tune modal. Logic unchanged. */

import { useState, useContext } from 'react';

import { FinancialBuilderContext } from '../FinancialBuilderPage.jsx';
import { genericPOSTDatabaseCall } from '../../helperFunctions.jsx';
import { costAllocationsRenderFields, industryDetails } from '../../constants.jsx';
import { renderFbField, FbIcons } from '../fbUI.jsx';

const { SaveOutlined } = FbIcons;

async function saveCompanyToDatabase(company) { return genericPOSTDatabaseCall('/api/fb/saveCompanyInfo', { company }, 'company info'); }

function CostAllocations({ contextToUse }) {
  const { companySelected, messageApi, setCompanySelected } = useContext(contextToUse || FinancialBuilderContext);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true); messageApi.loading('Saving company info...', 0);
    try {
      await saveCompanyToDatabase({ ...companySelected, id: companySelected.fb_id !== undefined ? companySelected.fb_id : companySelected.id });
      messageApi.destroy(); messageApi.success('Company info saved successfully');
    } catch (e) { console.error('Error saving company info:', e); messageApi.destroy(); messageApi.error('Failed to save company info'); }
    setSaving(false);
  };

  const handleInputChange = (event, company, key) => { setCompanySelected((prev) => ({ ...prev, [key]: event.target.value })); };
  const handleInputBlur = (event, company, key, field) => {
    let newValue = event.target.value;
    const fallback = () => (industryDetails[company.industry] ? industryDetails[company.industry][key] : field.default || '');
    if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) { messageApi.error(field.errorMessage); newValue = fallback(); }
    if (newValue === '') { messageApi.error('This field cannot be empty'); newValue = fallback(); }
    setCompanySelected((prev) => ({ ...prev, [key]: newValue }));
  };

  // Look up field defs by key so we can lay them out as grouped (cost → its
  // efficiency) rather than a flat grid where the three "Cost Efficiency %"
  // fields lose the context of which cost they belong to.
  const fieldByKey = Object.fromEntries(costAllocationsRenderFields.map((f) => [f.key, f]));
  const renderField = (key) => renderFbField(fieldByKey[key], companySelected, handleInputChange, true, handleInputBlur);
  const allocationGroups = [
    { costKey: 'cor_product_dev', effKey: 'cor_product_dev_eff' },
    { costKey: 'cor_gto_and_operational', effKey: 'cor_gto_and_operational_eff' },
    { costKey: 'cor_infrast_and_admin', effKey: 'cor_infrast_and_admin_eff' },
  ];

  return (
    <div className="pn-modal-embed pn-alloc-embed">
      <div className="pn-fieldset">
        <div className="pn-fieldset-title">Firm-wide CoR %</div>
        <div className="pn-fields pn-fields-1">{renderField('firm_cor')}</div>
      </div>
      <div className="pn-fieldset">
        <div className="pn-fieldset-title">Cost allocation</div>
        <div className="pn-alloc-list">
          {allocationGroups.map(({ costKey, effKey }) => (
            <div className="pn-alloc-group" key={costKey}>
              {renderField(costKey)}
              <div className="pn-alloc-eff">{renderField(effKey)}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="pn-editor-foot"><div className="sp" />
        <button type="button" className="pn-btn pn-btn-accent" disabled={saving} onClick={handleSave}><SaveOutlined /> Save</button>
      </div>
    </div>
  );
}

export default CostAllocations;
